<template>
  <b-modal id="relatarProblemaEmSimuladoModal" size="lg" hide-footer hide-header :no-enforce-focus="true" centered content-class="relatarProblemaEmSimuladoEstruturaModal">
    <div class="row w-50 p-3">
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('relatarProblemaEmSimuladoModal')" id="botaoFecharModalDeRelatarProblemaEmSimulado">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="col-md-11">
          <b-alert id="alertaRelatoProblema" variant="success" dismissible :show="mostrarAlertaDeBemSucedidoRelatoDeProblema" @dismissed="mostrarAlertaDeBemSucedidoRelatoDeProblema=false">
            <div>Obrigado pela avaliação!</div>
          </b-alert>
        </div>
        <div class="col-md-11">
          <b-alert id="alertaRelatoProblema" variant="danger" dismissible :show="mostrarAlertaDeMalSucedidoRelatoDeProblema" @dismissed="mostrarAlertaDeMalSucedidoRelatoDeProblema=false">
            <div>Sua solicitação não pôde ser registrada!</div>
          </b-alert>
        </div>
          <div class="form-group col-md-12">
            <div class="col-md-11 text-justify">
              <label id="relatoProblemaSimuladoLabel" for="problemaSimulado">Encontrou algum bug ou problema na questão? Relate o que aconteceu para que possamos solucionar:</label>
            </div>
            <div class="col-md-11">
              <textarea class="form-control" id="problemaSimulado" rows="4" v-model="textoDoProblemaSimulado"></textarea>
            </div>
          </div>
          <div class="text-center col-md-12">
            <button class="btn btn-primary mt-2 text-center" id="btn-enviar-relato-problema-simulado" @click="enviarRelatoDeProblemaSimulado()" :disabled="enviandoRelatoDeProblemaSimulado || !textoDoProblemaSimulado">
              <template id="enviarRelatoDeProblema" v-if="enviandoRelatoDeProblemaSimulado"><i class="fas fa-spinner fa-spin"></i> Enviando...</template>
              <template id="enviandoRelatoDeProblema" v-else> Enviar</template>
            </button>
          </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import RelatoProblemaSimuladoAPI from '@/api/relato-problema-simulado-api'

export default {
  name: 'ModalRelatarProblemaSimulado',
  inheritAttrs: false,
  props: {
    simuladoId: Number,
    questaoId: Number
  },
  data () {
    return {
      textoDoProblemaSimulado: '',
      mostrarAlertaDeBemSucedidoRelatoDeProblema: false,
      mostrarAlertaDeMalSucedidoRelatoDeProblema: false,
      enviandoRelatoDeProblemaSimulado: false
    }
  },
  methods: {
    enviarRelatoDeProblemaSimulado: function () {
      this.enviandoRelatoDeProblemaSimulado = true
      let url = window.location.href
      RelatoProblemaSimuladoAPI.registrarRelatoProblemaSimulado(this.simuladoId, this.textoDoProblemaSimulado, url, this.questaoId).then(() => {
      }).then(() => {
        this.enviandoRelatoDeProblemaSimulado = false
        this.mostrarAlertaDeBemSucedidoRelatoDeProblema = true
        this.mostrarAlertaDeMalSucedidoRelatoDeProblema = false
        this.textoDoProblemaSimulado = ''
      })
        .catch(() => {
          this.enviandoRelatoDeProblemaSimulado = false
          this.mostrarAlertaDeMalSucedidoRelatoDeProblema = true
          this.mostrarAlertaDeBemSucedidoRelatoDeProblema = false
        })
    },
    show: function () {
      this.$bvModal.show('relatarProblemaEmSimuladoModal')
    }
  }
}
</script>
